export default "__VITE_ASSET__DrsgIlqn__"